import React, { useEffect, useRef, useState } from 'react';

const noticeTitle = "Important Update on Picxy’s Stock Image Licensing:";
const noticePrefix = "Photographers & Subscribed Users are requested to check details on our updated ";
const termsUrl = "/terms_and_conditions#StockImageLicensing"; // replace with your actual route

export default function LicenseNotice() {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const closeTimerRef = useRef(null);

  useEffect(() => {
    setIsVisible(true);

    return () => {
      if (closeTimerRef.current) {
        window.clearTimeout(closeTimerRef.current);
      }
    };
  }, []);

  const handleClose = () => {
    if (isClosing) return;

    setIsClosing(true);
    closeTimerRef.current = window.setTimeout(() => {
      setIsVisible(false);
    }, 220);
  };

  if (!isVisible) return null;

  return (
    <>
      <div
        className={`license-toast${isClosing ? ' license-toast--closing' : ''}`}
        role="status"
        aria-live="polite"
        aria-atomic="true"
        aria-label="Important licensing update"
      >
        <button
          type="button"
          className="license-toast__close"
          onClick={handleClose}
          aria-label="Dismiss notice"
        >
          ×
        </button>

        <div className="license-toast__content">
          <p className="license-toast__title">{noticeTitle}</p>

          <p className="license-toast__body">
            {noticePrefix}
            <a
              href={termsUrl}
              className="license-toast__link"
            >
              Terms & Conditions
            </a>
          </p>
        </div>
      </div>

      <style jsx>{`
        .license-toast {
          position: fixed;
          right: 24px;
          bottom: 24px;
          z-index: 2200;
          max-width: min(420px, calc(100vw - 24px));
          padding: 14px 44px 14px 16px;
          border-radius: 16px;
          background: rgba(8, 17, 31, 0.96);
          color: #f0f4ff;
          box-shadow: 0 18px 45px rgba(0, 0, 0, 0.24);
          border: 1px solid rgba(0, 194, 204, 0.24);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          display: flex;
          align-items: flex-start;
          pointer-events: auto;
          animation: license-toast-in 220ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
        }

        .license-toast--closing {
          animation: license-toast-out 220ms ease both;
        }

        .license-toast__content {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .license-toast__title {
          margin: 0;
          font-size: 0.95rem;
          font-weight: 700;
          line-height: 1.4;
          color: #f0f4ff;
        }

        .license-toast__body {
          margin: 0;
          font-size: 0.9rem;
          line-height: 1.45;
          color: rgba(240, 244, 255, 0.86);
        }

        .license-toast__link {
          color: #b11226 !important;
          text-underline-offset: 2px;
          font-weight: 800;
        }

        .license-toast__link:hover,
        .license-toast__link:focus-visible {
          color: #c7253b !important;
          outline: none;          
          text-decoration: underline;
        }

        .license-toast__close {
          position: absolute;
          top: 8px;
          right: 8px;
          width: 28px;
          height: 28px;
          border: 0;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.1);
          color: #f0f4ff;
          font-size: 1rem;
          line-height: 1;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        .license-toast__close:hover,
        .license-toast__close:focus-visible {
          background: rgba(0, 194, 204, 0.2);
          outline: none;
        }

        @keyframes license-toast-in {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes license-toast-out {
          from {
            opacity: 1;
            transform: translateY(0);
          }
          to {
            opacity: 0;
            transform: translateY(10px);
          }
        }

        @media (max-width: 767px) {
          .license-toast {
            left: 12px;
            right: 12px;
            bottom: 12px;
            max-width: none;
            border-radius: 14px;
            padding: 12px 40px 12px 14px;
          }

          .license-toast__title {
            font-size: 0.9rem;
          }

          .license-toast__body {
            font-size: 0.84rem;
          }
        }
      `}</style>
    </>
  );
}